/*
  House of Zena — Marketing Campaign & Attribution Tracker (Shopify Platform Edition)
  Captures first-touch and last-touch UTM parameters, ad click IDs (gclid, fbclid, ttclid),
  Shopify session tokens (_shopify_y, _shopify_s, _shopify_sa_p, _shopify_sa_t),
  and automatically syncs them to Shopify Cart Attributes for native order management and marketing reports.
*/

(function() {
  'use strict';

  var STORAGE_KEY_FIRST = 'zena_attr_first_touch';
  var STORAGE_KEY_LAST = 'zena_attr_last_touch';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : '';
  }

  function getUrlParams() {
    var params = {};
    var search = window.location.search.substring(1);
    if (!search) return params;

    var pairs = search.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      var key = decodeURIComponent(pair[0]).toLowerCase();
      var value = decodeURIComponent(pair[1] || '');
      params[key] = value;
    }
    return params;
  }

  function captureAttribution() {
    try {
      var urlParams = getUrlParams();
      var hasCampaignData = urlParams.utm_source || urlParams.utm_campaign || urlParams.utm_medium || urlParams.gclid || urlParams.fbclid || urlParams.ttclid || urlParams.campaign_id || urlParams.ad_id;

      var shopifyY = getCookie('_shopify_y');
      var shopifyS = getCookie('_shopify_s');
      var shopifySaP = getCookie('_shopify_sa_p');
      var shopifySaT = getCookie('_shopify_sa_t');

      var currentSession = {
        utm_source: urlParams.utm_source || (document.referrer ? new URL(document.referrer, window.location.origin).hostname : 'direct'),
        utm_medium: urlParams.utm_medium || (urlParams.gclid ? 'cpc' : (urlParams.fbclid ? 'paid_social' : (document.referrer ? 'referral' : 'none'))),
        utm_campaign: urlParams.utm_campaign || 'none',
        utm_term: urlParams.utm_term || '',
        utm_content: urlParams.utm_content || '',
        campaign_id: urlParams.campaign_id || urlParams.utm_id || '',
        ad_id: urlParams.ad_id || '',
        gclid: urlParams.gclid || '',
        fbclid: urlParams.fbclid || '',
        ttclid: urlParams.ttclid || '',
        landing_page: window.location.pathname,
        landing_page_url: window.location.href,
        referrer: document.referrer || '',
        shopify_y: shopifyY,
        shopify_s: shopifyS,
        shopify_sa_p: shopifySaP,
        shopify_sa_t: shopifySaT,
        timestamp: new Date().toISOString()
      };

      // 1. Record First Touch if never recorded before
      if (!localStorage.getItem(STORAGE_KEY_FIRST)) {
        localStorage.setItem(STORAGE_KEY_FIRST, JSON.stringify(currentSession));
      }

      // 2. Record Last Touch if campaign data exists or no last touch exists
      if (hasCampaignData || !sessionStorage.getItem(STORAGE_KEY_LAST)) {
        sessionStorage.setItem(STORAGE_KEY_LAST, JSON.stringify(currentSession));
        localStorage.setItem(STORAGE_KEY_LAST, JSON.stringify(currentSession));
      }

      // 3. Sync to Shopify Cart Attributes (deferred to idle time, only if campaign data exists)
      if (hasCampaignData) {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(syncToShopifyCart, { timeout: 10000 });
        } else {
          setTimeout(syncToShopifyCart, 10000);
        }
      }
    } catch(err) {
      // Non-blocking catch
    }
  }

  function syncToShopifyCart() {
    try {
      var rawLast = sessionStorage.getItem(STORAGE_KEY_LAST) || localStorage.getItem(STORAGE_KEY_LAST);
      var rawFirst = localStorage.getItem(STORAGE_KEY_FIRST);

      var lastTouch = rawLast ? JSON.parse(rawLast) : null;
      var firstTouch = rawFirst ? JSON.parse(rawFirst) : null;

      if (!lastTouch && !firstTouch) return;

      var attributes = {};
      if (lastTouch) {
        if (lastTouch.utm_source) attributes['utm_source'] = lastTouch.utm_source;
        if (lastTouch.utm_medium) attributes['utm_medium'] = lastTouch.utm_medium;
        if (lastTouch.utm_campaign && lastTouch.utm_campaign !== 'none') attributes['utm_campaign'] = lastTouch.utm_campaign;
        if (lastTouch.utm_content) attributes['utm_content'] = lastTouch.utm_content;
        if (lastTouch.utm_term) attributes['utm_term'] = lastTouch.utm_term;
        if (lastTouch.campaign_id) attributes['campaign_id'] = lastTouch.campaign_id;
        if (lastTouch.ad_id) attributes['ad_id'] = lastTouch.ad_id;
        if (lastTouch.gclid) attributes['gclid'] = lastTouch.gclid;
        if (lastTouch.fbclid) attributes['fbclid'] = lastTouch.fbclid;
        if (lastTouch.ttclid) attributes['ttclid'] = lastTouch.ttclid;
        if (lastTouch.landing_page) attributes['landing_page'] = lastTouch.landing_page;
        if (lastTouch.landing_page_url) attributes['landing_page_url'] = lastTouch.landing_page_url;
        if (lastTouch.shopify_y || getCookie('_shopify_y')) attributes['shopify_visitor_token'] = lastTouch.shopify_y || getCookie('_shopify_y');
        if (lastTouch.shopify_s || getCookie('_shopify_s')) attributes['shopify_session_token'] = lastTouch.shopify_s || getCookie('_shopify_s');
      }
      if (firstTouch && firstTouch.utm_source) {
        attributes['first_source'] = firstTouch.utm_source;
      }

      // Send to Shopify Cart API in background only if real campaign data exists
      var hasRealCampaign = attributes['utm_source'] || attributes['utm_campaign'] || attributes['gclid'] || attributes['fbclid'];
      if (hasRealCampaign && Object.keys(attributes).length > 0 && window.Shopify && window.Shopify.routes) {
        fetch(`${window.Shopify.routes.cart_update_url || '/cart/update'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).catch(function() {});
      }
    } catch(e) {}
  }

  window.zenaAttribution = {
    capture: captureAttribution,
    sync: syncToShopifyCart,
    getFirstTouch: function() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY_FIRST)); } catch(e) { return null; }
    },
    getLastTouch: function() {
      try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY_LAST) || localStorage.getItem(STORAGE_KEY_LAST)); } catch(e) { return null; }
    }
  };

  // Listen for DOMReady and cart mutation events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', captureAttribution);
  } else {
    captureAttribution();
  }

  window.addEventListener('kt.cart.added', syncToShopifyCart);
})();
